import script from "./PreferredContractorsWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./PreferredContractorsWidget.vue?vue&type=script&setup=true&lang=js"

import "./PreferredContractorsWidget.vue?vue&type=style&index=0&id=53a3deed&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53a3deed"]])

export default __exports__